import { ClockIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { Freshness } from './utils';

interface Props {
  freshness: Freshness;
  compact?: boolean;
}

export function FreshnessLabel(props: Props) {
  const { freshness, compact = false } = props;

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 whitespace-nowrap text-xs',
        freshness.delayed
          ? 'text-amber-700 dark:text-amber-400'
          : 'text-onlight-text-2 dark:text-ondark-text-2',
        !compact && 'rounded-full px-2 py-1',
        !compact && freshness.delayed && 'bg-amber-500/10'
      )}
    >
      <ClockIcon className="h-3.5 w-3.5 flex-none" aria-hidden="true" />
      {compact ? freshness.shortLabel : freshness.label}
    </span>
  );
}

export default FreshnessLabel;
